module.exports = (parcelRequire.load("7My2F")).then(() => parcelRequire('j5qgM'));